export default __webpack_public_path__ + "static/media/3.dc2f6bee.png";